/**
 * @param {Cart} cart
 * @param {CartLine} cartLine
 *
 * @returns {CartLine[]
 */
const getChildLinesForLine = (cart, cartLine) => {
    return cart.itemList.filter((l) => {
        return l.parentThirdPartyRef && l.parentThirdPartyRef === cartLine.thirdPartyRef;
    });
};

/**
 * Each line in the cart has an array called childLines.
 * This contains references to all the other lines in the cart that have this line as their parentThirdPartyRef.
 * Calling this method will update those references for all lines in the cart.
 *
 * @param {Cart} cart
 */
const updateChildLineReferences = (cart) => {
    cart.itemList.forEach((cartLine) => {
        cartLine.childLines = getChildLinesForLine(cart, cartLine);
    });
};

/**
 * @param {Cart} cart
 */
const removeOrphanedLines = (cart) => {
    cart.itemList = cart.itemList.filter((cartLine) => {
        if (cartLine.parentThirdPartyRef) {
            // Return true if the parent line still exists in the cart.
            return cart.itemList.some((line) => line.thirdPartyRef === cartLine.parentThirdPartyRef);
        }
        return true;
    });
};

module.exports = {
    getChildLinesForLine,
    removeOrphanedLines,
    updateChildLineReferences,
};
